
export default {
  name: 'FilterToggle',
  props: {
    filterOptions: {
      type: Array,
      required: true,
      default: () => [],
    },
    actualValue: {
      type: Object,
      required: true,
      default: () => {},
    },
    filterTitle: {
      type: String,
      required: false,
      default: '',
    },
    mode: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
       type: this.mode && this.mode?.split(' '),
    }
  },
  computed: {
    activeItem() {
      return this.actualValue !== null? this.actualValue : this.filterOptions[0]
    },
    isLink() {
      return this.type && this.type.includes('link');
    },
    /**
     * Computes the target attribute for a link element based on the component's state.
     * - Returns '_self' if the component is not a link.
     * - If the `type` array contains an item starting with 'target_', extracts and returns the target value (e.g., '_blank').
     * - Defaults to '_self' if no valid target is found.
     * @returns {string} The target attribute value for the link.
     */
    linkTarget() {
      if (!this.isLink) return '_self';
      const targetItem = this.type.find(item => item.startsWith('target_'));
      if (targetItem) {
        const splitTarget = targetItem.split('target_')[1];
        return splitTarget || '_self';
      }
      return '_self';
    }
  },
  mounted() {
  },
  watch: {
    actualValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        return newValue;
      }
    }
  },
  methods: {
    updateItem(item) {
      this.$emit('update:actualValue', item);
    }
  }
}
